import {BaseApi} from './base-api';
import Vue from 'vue';

export class BookingApi extends BaseApi {
  static apiUri = 'bookings';

  /** @return {Promise<PagedHttpResponse<BookingBasicDto>>} */
  static getAll (params = null) {
    return super.getAll(params);
  }

  /** @return {Promise<EntityHttpResponse<BookingBasicDto>>} */
  static getById (id) {
    return super.getById(id);
  }

  /** @return {Promise<EntityHttpResponse<BookingBasicDto>>} */
  static updateBooking (id, updatedBooking) {
    return Vue.http.patch(this.apiUri + '/' + id, updatedBooking);
  }

  /** @return {Promise<>} */
  static disableBooking (bookingId) {
    return Vue.http.delete(this.apiUri + '/' + bookingId);
  }

  /** @return {Promise<>} */
  static restoreBooking (bookingId) {
    return Vue.http.post(this.apiUri + '/' + bookingId + '/restore');
  }

  /** @return {Promise<>} */
  static closeBooking (bookingId) {
    return Vue.http.post(this.apiUri + '/' + bookingId + '/close');
  }

  /** @return {Promise<>} */
  static cancelBooking (bookingId) {
    return Vue.http.post(this.apiUri + '/' + bookingId + '/cancel');
  }

  /** @return {Promise<>} */
  static uncancelBooking (bookingId, uncancelBookingRequest) {
    return Vue.http.post(this.apiUri + '/' + bookingId + '/uncancel', uncancelBookingRequest);
  }

  /** @return {Promise<>} */
  static openBooking (bookingId) {
    return Vue.http.post(this.apiUri + '/' + bookingId + '/open');
  }

  /** @return {Promise<EntityHttpResponse<MiscBookingDto[]>>} */
  static getBookingMisc (bookingId) {
    return Vue.http.get(this.apiUri + '/' + bookingId + '/miscs');
  }

  /** @return {Promise<EntityHttpResponse<TransactionDto>>} */
  static getBookingTransaction (bookingId) {
    return Vue.http.get(this.apiUri + '/' + bookingId + '/transaction');
  }

  /** @return {Promise<EntityHttpResponse<TransactionDto>>} */
  static createBookingTransaction (bookingId) {
    return Vue.http.post(this.apiUri + '/' + bookingId + '/transaction');
  }

  /** @return {Promise<HttpResponse>} */
  static deleteBookingTransaction (bookingId) {
    return Vue.http.delete(this.apiUri + '/' + bookingId + '/transaction');
  }

  /** @return {Promise<HttpResponse>} */
  static markBookingTransactionAsNotNeeded (bookingId) {
    return Vue.http.post(this.apiUri + '/' + bookingId + '/transaction/not-needed');
  }

  /** @return {Promise<HttpResponse>} */
  static updateBookingConsumptions (bookingId, updateRequest) {
    return Vue.http.post(this.apiUri + '/' + bookingId + '/consumptions', updateRequest);
  }
}
